import React from "react";
import LegalPage from "./LegalPage";
import { termsContent } from "./legalContent";

/**
 * /terms — the document the signup checkbox links to.
 *
 * Shows the version number as well as the date: it is the value stored against
 * every account that accepted it, so a support conversation about "which terms
 * did they agree to" can be settled from the page itself.
 */
const Terms = () => <LegalPage content={termsContent} showVersion />;

export default Terms;
